import { empty, undefinedOrNull } from "../utils/Validation";

export function getSessionKey(){
  return "qepayd";
}

/**
 * Creates a new session of a user, this session is not an HTTP based session object, rather a simple token in sessionStorage.
 * This should not be used to put values in sessionStorage as it puts value against a specific key.
 *
 * Putting value other than the user login token will lead in session logout.
 *
 * @export
 * @param {*} token
 */
export function createSession(token) {
  sessionStorage.qepayd = JSON.stringify(token);
}

/**
 * Get the session (token) from the sessionStorage. If there is no session, returns null/undefined.
 * 
 * If the decoded token is needed, refer to @getDecodedToken() method
 * @export
 * @returns token
 */
export function getSession() {

  var session = sessionStorage.qepayd;

  if(!empty(session)){ 
    return JSON.parse(session);
  }else{
    return null;
  }
}

/**
 * Delete the session of a signed user from the sessionStorage
 *
 * @export
 */
export function clearSession() {
  sessionStorage.removeItem("qepayd");
}

export function getToken(){
  let session = getSession();
    if (!empty(session)) {
        return session.authentication.token;
    }
}

export function getRole(){
  let session = getSession();
    if (!empty(session)) {
        let roles = session.authentication.roles;

        if(roles.length > 0){
          return roles[0];
        }
    }
}

export function isCoachMarkDone(){
  let isCoachMarkDone = localStorage.qepaydCoach;
  return !empty(isCoachMarkDone);
}

export function setCoachMarkStreak(){
  localStorage.qepaydCoach = "1";
}

export function setLangPref(langPref){
  localStorage.qeddashLang = langPref;
}

export function getLangPref(){
  return localStorage.qeddashLang;
}

export function setZonePref(zonePref){
  if(empty(zonePref)|| undefinedOrNull(zonePref)){
    zonePref = "ind";
  }
  localStorage.qeddashZone = zonePref;
}

export function getZonePref(){
  return localStorage.qeddashZone;
}


export function isTaxDomain(){
  let isTaxdomain=false
  if(window.location.href.indexOf("qfixonline") > -1 && !isSocietyDomain()){
    isTaxdomain=true
  }
  return isTaxdomain
}

export function isSocietyDomain(){
  let isSociety=false
  if(window.location.href.toLowerCase().indexOf("society") > -1){
    isSociety=true
  }
  return isSociety
}


export function setApplicationInfo(app){
  sessionStorage.application = JSON.stringify(app);

}


export function getApplicationInfo(){
  let app = sessionStorage.application;

  if(!empty(app)){ 
    return JSON.parse(app);
  }else{
    return null;
  }
}

